"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ellipsis = void 0;

var ellipsis = function ellipsis(textOverflow) {
  return "\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ".concat(textOverflow || "ellipsis", ";\n    ");
};

exports.ellipsis = ellipsis;